import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import { CREATE_DOMAIN, DELETE_DOMAIN, EDIT_DOMAIN, GET_DOMAINS, GET_DOMAINS_SUCCESS } from './domain.types';
import { authService } from './domain.service';

/** Domains */

function* getDomains({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getDomainsService, payload?.params);
        yield put({
            type: GET_DOMAINS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createDomain({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createDomainService, payload?.body);
        // const res = yield call(authService.getDomainsService, payload?.params);
        // yield put({
        //     type: GET_DOMAINS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editDomain({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editDomainService, payload?.id, payload?.body);
        // const res = yield call(authService.getDomainsService, payload?.params);
        // yield put({
        //     type: GET_DOMAINS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteDomain({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteDomainService, payload?.id);
        // const res = yield call(authService.getDomainsService, payload?.params);
        // yield put({
        //     type: GET_DOMAINS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchDomains = function* watchDomainsAuth() {
    /** Domains  */
    yield takeLatest(GET_DOMAINS, getDomains);
    yield takeLatest(CREATE_DOMAIN, createDomain);
    yield takeLatest(EDIT_DOMAIN, editDomain);
    yield takeLatest(DELETE_DOMAIN, deleteDomain);
    /** End */
};
